import { NgModule } from "@angular/core";

import { NormalizeInputValueDirective } from "./normalize-input-value.directive";

const DIRECTIVES = [NormalizeInputValueDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class NormalizeInputValueModule {}
